import * as moment from 'moment'

export class Plan {
  name: string
  marketingName: string
  stripePlanId: string
  appleProductId: string
  priceInCents: number
  interval: 'monthly'
  features: string[]
  comingAtMessage: string | null
  isActive: boolean

  constructor(data: { [key: string]: any }) {
    this.name = data.name
    this.marketingName = data.marketingName
    this.stripePlanId = data.stripePlanId
    this.appleProductId = data.appleProductId
    this.priceInCents = data.priceInCents
    this.interval = data.interval
    this.features = data.features
    this.comingAtMessage = data.comingAtMessage || null
    this.isActive = data.isActive
  }
}

export class StripeIban {
  country: string
  bankCode: string
  lastFour: string

  constructor(data: { [key: string]: any }) {
    this.country = data.country
    this.bankCode = data.bankCode
    this.lastFour = data.lastFour
  }
}

export class StripeAddress {
  city: string
  line1: string
  line2: string | null
  postalCode: string

  constructor(data: { [key: string]: any }) {
    this.city = data.city
    this.line1 = data.line1
    this.line2 = data.line2 || null
    this.postalCode = data.postalCode
  }
}

export class BillingSubscriptionManualModel {
  plan: Plan
  expiresAt: moment.Moment

  constructor(plan: Plan, data: { [key: string]: any }) {
    this.plan = plan
    this.expiresAt = moment(data.expiresAt)
  }
}

export class BillingSubscriptionAppleModel {
  plan: Plan
  expiresAt: moment.Moment

  constructor(plan: Plan, data: { [key: string]: any }) {
    this.plan = plan
    this.expiresAt = moment(data.expiresAt)
  }
}

export class BillingSubscriptionStripeModel {
  plan: Plan
  status: string
  name: string
  email: string
  vatId: string
  iban: StripeIban
  address: StripeAddress
  expiresAt: moment.Moment
  trialEndsAt: moment.Moment | null

  constructor(plan: Plan, iban: StripeIban, address: StripeAddress, data: { [key: string]: any }) {
    this.plan = plan
    this.iban = iban
    this.address = address
    this.status = data.status
    this.name = data.name
    this.email = data.email
    this.vatId = data.vatId
    this.expiresAt = moment(data.expiresAt)
    this.trialEndsAt = data.trialEndsAt ? moment(data.trialEndsAt) : null
  }
}

export class BillingSubscriptionModel {
  type: 'manual' | 'apple' | 'stripe'
  data: BillingSubscriptionManualModel | BillingSubscriptionAppleModel | BillingSubscriptionStripeModel

  constructor(data: { [key: string]: any }) {
    const plan = new Plan(data.data.plan)
    this.type = data.type

    if (this.type === 'stripe') {
      const iban = new StripeIban(data.data.iban)
      const address = new StripeAddress(data.data.address)

      this.data = new BillingSubscriptionStripeModel(plan, iban, address, data.data)
    } else if (this.type === 'manual') {
      this.data = new BillingSubscriptionManualModel(plan, data.data)
    } else if (this.type === 'apple') {
      this.data = new BillingSubscriptionAppleModel(plan, data.data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/billing/billing-subscription-model.ts